import React from "react";

function Box({ item, toggleOneBox, fontStyle }) {
  const { name, romaji, select, categoryTitle } = item;
  function BoxText() {
    if (categoryTitle !== undefined) {
      return <p>{categoryTitle}</p>;
    }
    return (
      <p>
        <span style={{ fontFamily: fontStyle }}>{name}</span>/{romaji}
      </p>
    );
  }

  return (
    <label
      className={select ? "select-box check" : "select-box"}
      htmlFor={name}
    >
      <input
        onChange={toggleOneBox}
        type="checkbox"
        id={name}
        checked={select}
        key={name}
      />
      <BoxText />
    </label>
  );
}

export default Box;
